"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.data = [
    {
        id: 1,
        name: 'SAME_DAY',
    },
];
